function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50,27.7c-12.4,0-22.3,10-22.3,22.3c0,12.4,10,22.3,22.3,22.3S72.3,62.4,72.3,50S62.4,27.7,50,27.7z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.1,43.2c-0.5,0-0.9-0.1-1.4-0.2c-2.4-0.8-3.7-3.3-2.9-5.7C10.9,15.6,25.3,8,37.2,3.9c2.3-0.8,4.9,0.4,5.7,2.7 c0.8,2.3-0.4,4.9-2.7,5.7c-18.6,6.6-24.4,17.2-27.8,27.7C11.7,42,10,43.2,8.1,43.2z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.6,96.6c-0.5,0-0.9-0.1-1.4-0.2C15.6,89.3,8,74.8,3.8,63c-0.8-2.3,0.4-4.9,2.7-5.7c2.3-0.8,4.9,0.4,5.7,2.7 C18.9,78.6,29.5,84.4,40,87.8c2.4,0.8,3.7,3.3,2.9,5.7C42.3,95.4,40.5,96.6,38.6,96.6z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91.9,43.1c-1.9,0-3.7-1.2-4.3-3.1c-3.4-10.5-9.2-21.1-27.8-27.7c-2.3-0.8-3.6-3.4-2.7-5.7c0.8-2.3,3.4-3.6,5.7-2.7 c22.5,7.9,29.6,22,33.4,33.4c0.8,2.4-0.5,4.9-2.9,5.7C92.8,43,92.4,43.1,91.9,43.1z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.4,96.5c-1.9,0-3.7-1.2-4.3-3.1c-0.8-2.4,0.5-4.9,2.9-5.7c10.5-3.4,21.1-9.2,27.7-27.8c0.8-2.3,3.4-3.6,5.7-2.7 c2.3,0.8,3.6,3.4,2.7,5.7c-7.9,22.5-22,29.6-33.4,33.4C62.3,96.4,61.8,96.5,61.4,96.5z"
});

var SvgSelectedProject = function SvgSelectedProject(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSelectedProject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Selected-Project.88c59e83.svg";
export { ForwardRef as ReactComponent };